import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { toast } from 'sonner';
import { Loader2, MessageSquare } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_40c7321e-fdf9-4402-813d-639ea853bfad/artifacts/ve1f0xa3_logo%20SMH.png";

const LoginPage = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Inicio de sesión exitoso');
    } catch (error) {
      const message = error.response?.data?.detail || 'Error al iniciar sesión';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F0F2F5] p-4">
      <Card className="w-full max-w-md shadow-lg border-0" data-testid="login-card">
        <CardHeader className="text-center pb-2">
          <div className="flex justify-center mb-4">
            <img 
              src={LOGO_URL} 
              alt="SmartBoat MessageHub" 
              className="h-20 object-contain"
              data-testid="login-logo"
            />
          </div>
          <CardTitle className="text-2xl font-bold text-[#2C3E50]">Panel de Administración</CardTitle>
          <CardDescription className="text-[#6B7B8C]">
            Ingresa tus credenciales para acceder
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email" className="text-[#2C3E50]">Email</Label>
              <Input
                id="email"
                type="email"
                placeholder="admin@ejemplo.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="login-email-input"
                className="border-[#E9EDEF] focus:border-[#0066CC] focus:ring-[#0066CC]/20"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password" className="text-[#2C3E50]">Contraseña</Label>
              <Input
                id="password"
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="login-password-input"
                className="border-[#E9EDEF] focus:border-[#0066CC] focus:ring-[#0066CC]/20"
              />
            </div>
            <Button 
              type="submit" 
              className="w-full bg-[#0066CC] hover:bg-[#0052A3] text-white font-medium"
              disabled={loading}
              data-testid="login-submit-btn"
            >
              {loading ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Ingresando...
                </>
              ) : (
                <>
                  <MessageSquare className="mr-2 h-4 w-4" />
                  Iniciar Sesión
                </>
              )}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default LoginPage;
